import { jsx } from '@emotion/react';
import * as s from './noticeHTML.styles';
import { ArrowRight } from '@next-common/material-ui-icons';
/**
 * notice consent didomi
 * @returns {*}
 * @constructor
 */
function NoticeHTML({ noticeText }) {
    const openPreferences = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.preferences)
                window.Didomi.preferences.show();
        }
    };
    const acceptAll = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.setUserAgreeToAll)
                window.Didomi.setUserAgreeToAll();
        }
    };
    const refuseAll = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.setUserDisagreeToAll)
                window.Didomi.setUserDisagreeToAll();
        }
    };
    return (jsx("div", { className: "containerNotice", 
        // eslint-disable-next-line
        css: s.containerNotice },
        jsx("div", { className: "containerTxt", 
            // eslint-disable-next-line
            css: s.containerTxt },
            jsx("span", { className: "titleTxtStyle", 
                // eslint-disable-next-line
                css: s.titleTxtStyle }, "Vos pr\u00E9f\u00E9rences en mati\u00E8re de cookies"),
            jsx("div", { className: "containerContinueWithoutConsent", onClick: refuseAll, 
                // eslint-disable-next-line
                css: s.containerContinueWithoutConsent },
                jsx("span", { className: "continueWithoutConsentTxtStyle", 
                    // eslint-disable-next-line
                    css: s.continueWithoutConsentTxtStyle }, "Continuer sans accepter"),
                jsx("span", { className: "containerArrow", 
                    // eslint-disable-next-line
                    css: s.containerArrow },
                    jsx(ArrowRight, { fill: "black", width: "12px", height: "12px" }))),
            jsx("p", { className: "paragraphTxtStyle", 
                // eslint-disable-next-line
                css: s.paragraphTxtStyle, dangerouslySetInnerHTML: { __html: noticeText } })),
        jsx("div", { className: "containerBtn", 
            // eslint-disable-next-line
            css: s.containerBtn },
            jsx("div", { onClick: acceptAll, className: "didomi_accept_button", 
                // eslint-disable-next-line
                css: s.didomi_accept_button, onKeyPress: acceptAll },
                jsx("span", null, "Accepter et fermer")),
            jsx("div", { onClick: openPreferences, className: "preferencesBtn", 
                // eslint-disable-next-line
                css: s.preferencesBtn, onKeyPress: openPreferences },
                jsx("span", null, "Param\u00E9trer")))));
}
export default NoticeHTML;
